import * as moment from "moment";

export class CustomPremiumConfigurationForEmployee{

  id : number = -1 * moment().valueOf();
  customPremiumConfigurationId:number;
  employeeId:string;
  active:boolean;
  customPremiumConfigurationName: string;

}
